// extracted by mini-css-extract-plugin
module.exports = {"container":"preface-module--container--rpIU5","border":"preface-module--border--Ma3_T","preface":"preface-module--preface--1q996"};